import store from "@/store";
import axios from "axios";


export const studentCourseGuards = (to, from, next) => {

    const courseId = to.params.course_id;
    console.log(courseId, "%courseId%");

    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "student"){
            // next();
            axios.get(`${process.env.VUE_APP_API}/course-permission/${courseId}/?Key=${store.getters.userInfo.token_key}`)
                .then((response)=>{
                    if(response.data.status == 200){
                        next();
                    } 
                    else{
                        alert("not have course permisson");
                        setTimeout(()=>{
                            next("/student/mycourse");
                        },200)
                        return;
                    }  
                })
                .catch((error)=>{
                    alert("not have course permisson");
                     setTimeout(()=>{
                            next("/student/mycourse");
                        },200)
                    return;
                })
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};



export const adminhodcodGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "super_admin"  ||  store.getters.userInfo.user.permission == "hod" || store.getters.userInfo.user.permission == "co-ordinator"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};

export const isloginGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
    } 
    else{
        next("/");
    }
};


export const hodGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "hod"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};


export const mentorGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "mentor"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};

export const coOrdianateGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "co-ordinator"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};

export const adminGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "super_admin"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};


export const studentGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "student"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};

export const instructorGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "instructor"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};


export const loginGuards = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next();
    } 
    else {
        if(store.getters.userInfo.user.permission == "super_admin"){
            next("/admin/home");
        }
        if(store.getters.userInfo.user.permission == "student"){
            next("/student/home");
        }
        if(store.getters.userInfo.user.permission == "instructor"){
            next("/instructor/home");
        }
        if(store.getters.userInfo.user.permission == "hod"){
            next("/hod/home");
        }
        if(store.getters.userInfo.user.permission == "mentor"){
            next("/mentor/home");
        }
        if(store.getters.userInfo.user.permission == "co-ordinator"){
            next("/coordinater/home");
        }
    }
};

